var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showVerified)?_c('div',{staticClass:"alert alert-danger m-0"},[_vm._v(" "+_vm._s(_vm.$t('profileNonVerifiedText'))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }